<template>
  <div class="common">
    <div class="page-btns-main">
      <div class="page-main no-shadow">
        <a-steps :current="current" class="common-step">
          <a-step
            v-for="item in steps"
            :key="item.title"
            :title="item.title"
          ></a-step>
        </a-steps>
      </div>

      <div>
        <keep-alive
          ><component
            ref="bankComp"
            :is="steps[current].comp"
            :params="steps[current].params"
            :text="steps[current].text"
            :readonly="true"
            :bankCd.sync="bankCd"
          ></component
        ></keep-alive>
      </div>
    </div>
    <div class="spaceCenter page-bottom-btns">
      <a-button
        v-if="current == 0"
        type="primary"
        class="btn-big"
        @click="next"
      >
        下一步
      </a-button>
      <a-button
        type="primary"
        v-if="current == 1"
        style="margin-left: 8px"
        class="btn-big"
        @click="prev"
      >
        上一步
      </a-button>
      <a-button class="btn-big" @click="goback">
        返回
      </a-button>
    </div>
  </div>
</template>

<script>
import bankInfoBase from "./bank-info-base";
import bankInfoSupplement from "./bank-info-supplement";
export default {
  components: {
    bankInfoBase,
    bankInfoSupplement
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "基本信息",
          comp: "bankInfoBase",
          params: null
        },
        {
          title: "补充资料",
          comp: "bankInfoSupplement",
          params: null
        }
      ]
    };
  },
  computed: {
    bankCd() {
      return this.$route.params.bankCd;
    }
  },
  methods: {
    next() {
      if (this.current == 0) {
        this.current++;
      }
    },
    prev() {
      this.current--;
    },
    goback() {
      this.$router.push("/bank/bankList");
    }
  },
  created() {},
  watch: {}
};
</script>
<style scoped>
.common-step {
  width: 70%;
  margin: 18px auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/bank/bank-info.vue